import { useEffect, useState } from "react";
import { func } from "prop-types";
import { useTranslation } from "react-i18next";
import { EstimationUnits } from "@repo/utils";
import { COMPANY_SETTINGS } from "@client";
import { getCompanySettingsQuery, setCompanySettingsQuery } from "@query";
import { InfoLabel, Radio } from "@components";
import Grid from "@material-ui/core/Grid";

export const EstimationUnitSetter = ({
  onChange,
}) => {
  const { t } = useTranslation();
  
  const [ estimationUnit, setEstimationUnit ] = useState(null);
  
  useEffect(() => {
    (async () => {
      let u = await getCompanySettingsQuery(COMPANY_SETTINGS.ESTIMATION_UNIT);
      setEstimationUnit(u || EstimationUnits.HOURS);
      onChange?.(u || EstimationUnits.HOURS);
    })();
  }, []);
  
  const handleEstimationUnitChange = (e) => {
    const v = e.target.value;
    setEstimationUnit(v);
    onChange?.(v);
    setCompanySettingsQuery(COMPANY_SETTINGS.ESTIMATION_UNIT, v);
  }
  
  return (
    <Grid item container direction="column" wrap="nowrap" spacing={1} className="mb-4">
      <InfoLabel className="my-0" label="views.settings.menu.estimation_unit" />
      <Grid item xs={ 12 }>
        <Radio
          name="estimation-unit"
          aria-label="estimation-unit"
          value={EstimationUnits.HOURS}
          checked={estimationUnit === EstimationUnits.HOURS}
          onChange={handleEstimationUnitChange}
          className="mr-2"
          labelClassName="m-0 capitalize"
          label={t("times.hour")}
        />
      </Grid>
      <Grid item xs={ 12 }>
        <Radio
          name="estimation-unit"
          aria-label="estimation-unit"
          value={EstimationUnits.DAYS}
          checked={estimationUnit === EstimationUnits.DAYS}
          onChange={handleEstimationUnitChange}
          className="mr-2"
          labelClassName="m-0 capitalize"
          label={t("times.day")}
        />
      </Grid>
    </Grid>
  )
}

EstimationUnitSetter.propTypes = {
  onChange: func,
}